











































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobDto from '@/models/Jobs/JobDto';
import JobStatus from '@/models/Jobs/JobStatus';
import JobClosedReason from '@/models/Jobs/JobClosedReason';
import UpdateJobStatusRequest from '@/models/Jobs/UpdateJobStatusRequest';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'JobStatusSetClosed'
})
export default class extends GiganautVueDialog {
 
  jobStatus = JobStatus;
  closedReason: JobClosedReason = 0;

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.closedReason = 0;
    } 
    this.$emit("closeMenu");
  }

  get closedReasons() {
    return ListUtils.jobClosedReasonOptions();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateJobStatusRequest();
    request.updatedAt = JobDetailsModule.currentJob.updatedAt;
    request.status = JobStatus.Closed;
    request.closedReason = this.closedReason;
    await JobDetailsModule.updateJobStatus(request);
    this.dialog = false;
  }
}
